import { StatusUserI } from 'projects/access-control/src/app/Domain/Entities/group.interface';
import {
	Component,
	EventEmitter,
	HostListener,
	Input,
	OnChanges,
	OnInit,
	Output,
	SimpleChanges,
} from '@angular/core';

@Component({
	selector: 'app-dropdown-status',
	templateUrl: './dropdown-status.component.html',
	styleUrls: ['./dropdown-status.component.scss'],
})
export class DropdownStatusComponent implements OnInit, OnChanges {
	@Input() elements: StatusUserI[] = [];
	@Input() node: StatusUserI = {} as StatusUserI;
	@Output() elementSelected = new EventEmitter<StatusUserI>();
	click = false;
	active = false;
	constructor() {}

	ngOnInit(): void {}
	ngOnChanges(changes: SimpleChanges): void {
		// this.dropdown();
	}

	@HostListener('click')
	clicked() {
		this.click = true;
	}

	@HostListener('document:click')
	clickedOut() {
		const some_text = this.click ? 'Event Triggered' : 'Event Triggered Outside Component';
		if (some_text === 'Event Triggered Outside Component') {
			this.active = false;
		} else if (this.active) {
			this.active = true;
		}
		this.click = false;
	}

	dropdown() {
		this.active = !this.active;
	}

	elementSelectedItem(elem: StatusUserI) {
		this.elementSelected.emit(elem);
		this.dropdown();
	}
}
